module.exports = __webpack_public_path__ + "static/img/ewm.3d1f45dc.png";